import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useUserStore } from "../stores/userStore"
import { IconLogout, IconUsers } from "@tabler/icons-react"
import { Avatar, Menu, Text, UnstyledButton } from "@mantine/core"
import { ContributorsModal } from "./contributors-modal"

export function UserNav() {
  const user = useUserStore((state) => state.user)
  const clearUser = useUserStore((state) => state.clearUser)
  const navigate = useNavigate()
  const [isContributorsModalOpen, setIsContributorsModalOpen] = useState(false);

  if (!user) {
    return null
  }

  const getInitials = (name) => {
    if (!name) return "";
    const names = name.split(" ")
    if (names.length > 1) {
      return `${names[0][0]}${names[names.length - 1][0]}`.toUpperCase()
    }
    return name.substring(0, 2).toUpperCase()
  }

  return (
    <>
      <Menu shadow="md" width={200} position="bottom-end">
        <Menu.Target>
          <UnstyledButton>
            <Avatar src={user.avatar} radius="xl" color="cyan">
                {getInitials(user.name)}
            </Avatar>
          </UnstyledButton>
        </Menu.Target>

        <Menu.Dropdown>
          <Menu.Label>
            <Text size="sm" fw={500}>{user.name}</Text>
            <Text size="xs" c="dimmed">{user.email}</Text>
          </Menu.Label>
          <Menu.Divider />
          <Menu.Item leftSection={<IconUsers size={14} />} onClick={() => setIsContributorsModalOpen(true)}>
            Contributors
          </Menu.Item>
          <Menu.Divider />
          <Menu.Item 
            color="red" 
            leftSection={<IconLogout size={14} />}
            onClick={() => {
                clearUser();
                navigate('/login');
            }}
          >
            Log out
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
      <ContributorsModal isOpen={isContributorsModalOpen} setIsOpen={setIsContributorsModalOpen} />
    </>
  )
}
